import { Box, Flex, Text } from '@chakra-ui/react';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Link } from '@morressier/alembic';
import { useNavigate } from 'react-router-dom';
import { SubmissionFlowLayout } from 'src/pages/Organization/public/Journal/SubmissionUpload/components/SubmissionFlowLayout';

interface Props {
  shortname: string;
  submissionId: string;
  manuscriptId: string;
  submissionContextId: string;
  onBackToArchive: () => void;
}

const SUCCESS_MESSAGE =
  'Your submission has been cloned successfully. You can review the cloned submission now or return to the archive tab to continue managing your submissions.';

const CloneSubmissionSuccessState = ({
  shortname,
  submissionId,
  manuscriptId,
  submissionContextId,
  onBackToArchive
}: Props) => {
  const navigate = useNavigate();
  const archivePath = `/app/workspace/${shortname}/archive?activeTab=all`;
  const submissionPath = `/app/workspace/${shortname}/j/${submissionContextId}/submissions?selectedItem=${submissionId}&activeTab=overview`;
  const navigateToSubmission = () =>
    navigate(submissionPath, {
      state: { from: archivePath }
    });

  return (
    <SubmissionFlowLayout width="720px">
      <Flex
        height="112px"
        width="100%"
        background="successSecondaryFill"
        justifyContent="center"
        alignItems="center"
        borderRadius="base"
        color="successPrimaryContentAccent"
        marginBottom={8}
      >
        <FontAwesomeIcon fontSize={40} icon={faCircleCheck} />
      </Flex>

      <Box textAlign="center">
        <Text textStyle="headingTitle" marginBottom={2}>
          Submission Cloned
        </Text>
        <Link
          variant="primary"
          marginBottom={2}
          fontWeight="bold"
          onClick={navigateToSubmission}
        >
          Manuscript ID : {manuscriptId}
        </Link>
        <Text marginBottom={8}>{SUCCESS_MESSAGE}</Text>
        <Flex justifyContent="center" gap={3} wrap="wrap">
          <Button variant="secondary" onClick={onBackToArchive}>
            Go Back to Archive Tab
          </Button>
          <Button variant="primary" onClick={navigateToSubmission}>
            View Cloned Submission
          </Button>
        </Flex>
      </Box>
    </SubmissionFlowLayout>
  );
};

export default CloneSubmissionSuccessState;
